import { Alert, Grid } from '@mui/material';
import React from 'react';
import { OrderPageTypography } from './OrderPageTypography';

type OrderPageErrorProps = {
  message: string;
  isShowingError: boolean;
  setClearError: () => void;
};
export const OrderPageError = ({ message, isShowingError, setClearError }: OrderPageErrorProps) => {
  return (
    <Grid container mt={2} justifyContent="center" style={{ display: isShowingError ? 'flex' : 'none' }}>
      <Alert severity="error" onClose={setClearError}>
        <OrderPageTypography color="error">{message}</OrderPageTypography>{' '}
      </Alert>
    </Grid>
  );
};
